const toPercentage = (num: number): string => {
  return `${(Math.floor(num * 100000) / 1000).toFixed(2)}%`;
};

export default toPercentage;
